import { Injectable } from '@angular/core';
import * as _ from 'lodash';

class LoadingMessage {
  id: number = 0;
  text: string = '';

  constructor(text: string) {
    this.id = Date.now();
    this.text = text;
  }
}


@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  visible = false;
  messages = [] as LoadingMessage[];

  constructor() {}

  add(message: string) {
    let newMsg = new LoadingMessage(message);
    this.messages.push(newMsg);
    this.visible = true;
    return newMsg.id;
  }

  remove(id: number) {
    if (!id) return;
    _.remove(this.messages, (msg) => msg.id === id);
    this.visible = this.messages.length > 0;
  }
}
